import {Component, OnInit, Inject, DestroyRef, inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {RegexConstants} from '@emm/core/util/regex.constants';
import {AuthFacadeService} from '@emm/auth/services/auth-facade.service';
import {ConsumerService} from '@emm/core/services/consumer.service';
import {TagService} from '@emm/core/services/tag.service';
import {ConsumerType} from '@emm/core/models/consumer-type.model';

@Component({
    selector: 'emm-add-consumer-type-dialog',
    styleUrls: ['./add-consumer-type-dialog.component.scss'],
    templateUrl: './add-consumer-type-dialog.component.html'
})
export class AddConsumerTypeDialogComponent implements OnInit {

    private readonly destroyRef: DestroyRef = inject(DestroyRef);

    form: FormGroup;
    isReadOnly = this.authFacade.isReadOnly$;
    spaceValidatorPattern = RegexConstants.STARTING_SPACE_VALIDATIOR_PATTERN;

    constructor(
        private authFacade: AuthFacadeService,
        public consumerService: ConsumerService,
        public dialogRef: MatDialogRef<AddConsumerTypeDialogComponent>,
        public tagService: TagService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.buildForm();
    }



    ngOnInit(): void {
        this.dialogRef.updatePosition({ top: '100px' });
    }



    onNoClick(): void {
        this.dialogRef.close();
    }



    buildForm(): void {
        this.form = new FormGroup({
            name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
            tag: new FormControl('')
        });
    }



    findTagExists(): void {
        if (this.form.controls.tag.valid) {
            this.tagService.getConsumerTypeTags(this.form.get('tag').value)
                .pipe(
                    takeUntilDestroyed(this.destroyRef)
                )
                .subscribe(res => {
                if (res) {
                    this.form.controls.tag.setErrors({ tagExists: true });
                }
            });
        }
    }



    OnSubmit(): void {
        if (this.form.valid) {
            const consumerType = {
                name: this.form.controls.name.value,
                tag: this.form.controls.tag.value
            } as ConsumerType;

            this.consumerService.createConsumerType(consumerType)
                .pipe(
                    takeUntilDestroyed(this.destroyRef)
                )
                .subscribe(() => {
                this.dialogRef.close('submit');
            });
        }
    }



    noWhitespaceValidator(control: FormControl): {} {
        if (control.value.startsWith(' ') || control.value.endsWith(' ')) {
            return { invalidWhiteSpace: 'Invalid white space' };
        }
    }



}
